
import { useRoute, useRouter } from '@nuxtjs/composition-api';
import { storeToRefs } from 'pinia';
import { useChosenVariantDetailsStore } from '~/stores/useChosenVariantDetailsStore';

export default {
  props: {
    showBackBtn: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const chosenVariantDetailsStore = useChosenVariantDetailsStore()
    const {
      productDetails
    } = storeToRefs(chosenVariantDetailsStore)
    const route = useRoute()
    const router = useRouter()

    const backToListPage = () => {
      router.push('/' + route.value.params.categoryslug)
    }

    return {
      backToListPage,
      productDetails
    }
  }
}
